import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

const API_URL = "http://localhost:8080/api/test/";
const API_URL2 = "http://localhost:8080/user";
@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private http: HttpClient) {}

  getPublicContent(): Observable<any> {
    return this.http.get(API_URL + "all", { responseType: "text" });
  }

  getUserBoard(): Observable<any> {
    return this.http.get(API_URL + "user", { responseType: "text" });
  }

  getModeratorBoard(): Observable<any> {
    return this.http.get(API_URL + "mod", { responseType: "text" });
  }

  getAdminBoard(): Observable<any> {
    return this.http.get(API_URL + "admin", { responseType: "text" });
  }

  getAll() {
    return this.http.get(environment.Localurl + "user");
  }

  insert(data) {
    return this.http.post(environment.Localurl + "user", data);
  }

  delete(id) {
    return this.http.delete(environment.Localurl + "user" + "/" + id);
  }

  getOne(id) {
    return this.http.get(environment.Localurl + "user" + "/" + id);
  }
  update(id, data) {
    return this.http.put(environment.Localurl + "user" + "/" + id, data);
  }
}
